import { isValid, parse } from 'date-fns';
import { fr } from 'date-fns/locale';
import { format } from 'date-fns/esm';

export const withDatePicker = (setFieldValue, setFieldTouched, name, dateFormat = 'yyyy-MM-dd') => {
  const handleChangeRaw = e => {
    const { innerName = name, value } = e.target;
    let parsedDate = parse(value, dateFormat, new Date(), { locale: fr });
    if (!isValid(parsedDate) && dateFormat.length + 1 === value.length) {
      const nvalue = value.slice(0, -2) + value.slice(-1);
      parsedDate = parse(nvalue, dateFormat, new Date(), { locale: fr });
    }
    if (!isValid(parsedDate)) {
      e.preventDefault();
      setFieldValue(innerName, value);
      setFieldTouched(innerName, false);
    }

    if (isValid(parsedDate)) {
      const strDate = format(parsedDate, dateFormat);
      setFieldValue(innerName, strDate);
      setFieldTouched(innerName, true);
    }
  };

  const handleChange = date => {
    const dateInstance = new Date(date);
    const strDate = format(dateInstance, dateFormat);
    if (isValid(dateInstance)) {
      setFieldValue(name, strDate);
      setFieldTouched(name, true);
    }
  };

  return [handleChangeRaw, handleChange];
};
